import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import DataComponent from '../../../DataComponent/DataComponent';
import moment from 'moment-timezone';
import UserStore from '../../../../stores/UserStore';
import { I18nContext } from 'utils/I18n/context';

const CurrencyRatioPageContainer = ({
    headerNames,
    currencyRatios,
    totalPages,
    loading,
    currency,
    allCurrencyRatios,
    selectOptions,
    getCurrenciesList,
    onChangeData,
    getCurrencyRatios
}) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        headerNames: headerNames || [],
        currencyRatios: currencyRatios || [],
        totalPages: totalPages || 0,
        loading: loading || false,
        currency: currency || '',
        allCurrencyRatios: allCurrencyRatios || [],
        page: 1
    });

    const staticNames = t?.dataTable || {
        headers: { createdAt: 'Created At', filterByCurrency: 'Filter by Currency' },
        filter: 'Filter',
        rangeNames: {
            today: 'Today',
            yesterday: 'Yesterday',
            week: 'Week',
            month: 'Month',
            year: 'Year'
        }
    };
    const timezone = UserStore.getTimeZone();
    const staticNameCurrencyRatios = t?.exchangeRates?.title || 'Exchange Rates';

    const onChangeDataHandler = useCallback(() => {
        onChangeData(state, (data) => {
            setState(prev => ({
                ...prev,
                ...data
            }));
        });
    }, [onChangeData, state]);

    const onDataTableAction = useCallback((actionState, actionType) => {
        const isChangeData = actionType === 'selectChange' && state.page === 1;

        setState(prev => ({
            ...prev,
            page: actionState.page,
            currency: actionState.currency || prev.currency
        }));

        if (isChangeData) {
            onChangeDataHandler();
        } else {
            getCurrencyRatios(actionState);
        }
    }, [state.page, onChangeDataHandler, getCurrencyRatios]);

    useEffect(() => {
        const isChangeData = (state.loading && !loading) || state.currencyRatios.length > 0;

        setState(prev => ({
            ...prev,
            totalPages: totalPages || 0,
            loading: loading || false
        }));

        if (isChangeData) {
            onChangeDataHandler();
        }
    }, [totalPages, loading, state.loading, state.currencyRatios.length, onChangeDataHandler]);

    const toDay = moment().tz(timezone);

    return (
        <DataComponent
            onAction={onDataTableAction}
            totalPages={state.totalPages}
            multiLevelHeaderNames={state.headerNames}
            page={state.page}
            data={state.currencyRatios}
            loading={state.loading}
            isQuery={true}
            hideResetButton={true}
            currencySettings={true}
            currencySettingData={getCurrenciesList()}
            currencySettingKey={'currencies'}
            currencySettingAction={onDataTableAction}
            tableBodyTitle={staticNameCurrencyRatios}
            className="simple-table double-row-header green-hover"
            gray={true}
            fields={[
                {
                    name: 'datepicker',
                    key: 'create',
                    label: staticNames.headers.createdAt,
                    dropdownLabel: staticNames.filter,
                    disabled: true,
                    withList: true,
                    list: [
                        {title: staticNames.rangeNames.today, value: { startDate: toDay, endDate: toDay}},
                        {title: staticNames.rangeNames.yesterday, value: { startDate: toDay.clone().subtract(1, 'day'), endDate: toDay.clone().subtract(1, 'day')} },
                        {title: staticNames.rangeNames.week, value: { startDate: toDay.clone().subtract(1, 'week'), endDate: toDay} },
                        {title: staticNames.rangeNames.month, value: { startDate:toDay.clone().subtract(1, 'months'), endDate: toDay} },
                        {title: staticNames.rangeNames.year, value: { startDate: toDay.clone().subtract(1, 'year'), endDate: toDay} }
                    ]
                },
                {
                    key: 'currency',
                    data: selectOptions || [],
                    label: staticNames.headers.filterByCurrency,
                    disabled: true,
                    value: state.currency,
                    withoutDropdown: true,
                    withList: true,
                    showSubtitle: true,
                    list: (selectOptions && selectOptions.length > 0) ? selectOptions : [{title: state.currency, value: state.currency}]
                }
            ]}
        />
    );
};

CurrencyRatioPageContainer.propTypes = {
    currencyRatios: PropTypes.array,
    headerNames: PropTypes.array,
    totalPages: PropTypes.number,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    allCurrencyRatios: PropTypes.array,
    selectOptions: PropTypes.array,
    getCurrenciesList: PropTypes.func,
    onChangeData: PropTypes.func,
    getCurrencyRatios: PropTypes.func
};

CurrencyRatioPageContainer.defaultProps = {
    currencyRatios: [],
    headerNames: [],
    totalPages: 0,
    loading: false,
    currency: '',
    allCurrencyRatios: [],
    selectOptions: [],
    getCurrenciesList: () => [],
    onChangeData: () => {},
    getCurrencyRatios: () => {}
};

export { CurrencyRatioPageContainer };
